import React from 'react'
import DetailRow from './DetailRow'

import { numberAddCommas } from 'servos/formValidations'

class RateRowSplit extends React.Component {
  render() {
    const {
      title,
    } = this.props;

    return(
      <div className='p-3'>
        <div className='grey'>{ title }</div>
        <div className='mb-2'>
          { this.props.children }
        </div>
      </div>
    )
  }
}

export default RateRowSplit
